import { useEffect } from 'react';

import { Icon } from '@sravni/react-design-system';
import { Button } from '@sravni/react-design-system/lib/Button';
import { Card } from '@sravni/react-design-system/lib/Card';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text, Heading } from '@sravni/react-design-system/lib/Typography';
import { ArrowRight } from '@sravni/react-icons';

import { sendYmylHowToGetLoanView, sendYmylLicensedPlatformCbRfClick } from '@src/helpers/analyticsEvents';
import { syntheticOpen, WindowTargets } from '@src/helpers/synteticOpen';
import { isServer } from '@src/utils';

import styles from './SeoFinance.module.scss';
import { SeoFinanceTexts } from './SeoFinance.texts';

export const CB_RF_SRAVNI_LINK_URL = `https://cbr.ru/finorg/foinfo/?ogrn=1207700502107`;

export function SeoFinance() {
  useEffect(() => {
    if (isServer) {
      return;
    }
    sendYmylHowToGetLoanView();
  }, []);

  const handleClickCbRefSite = () => {
    sendYmylLicensedPlatformCbRfClick();
    syntheticOpen({ href: CB_RF_SRAVNI_LINK_URL, target: WindowTargets.BLANK_NO_OPENER });
  };
  return (
    <Card className={styles.container}>
      <Space direction="column" className={styles.content}>
        <Space direction="column" size={8}>
          <Heading level={3}>{SeoFinanceTexts.title}</Heading>
          <Text className={styles.subheading}>{SeoFinanceTexts.subheading}</Text>
        </Space>
        <div className={styles.grid}>
          <Card className={styles.internalCard}>{SeoFinanceTexts.description}</Card>
          <Space direction="column" justify="flex-start" className={styles.descriptionCard}>
            <Text className={styles.miniDescription}>{SeoFinanceTexts.legalInfo}</Text>
            <Button size={52} color="blue" variant="text" className={styles.button} onClick={handleClickCbRefSite}>
              {SeoFinanceTexts.buttonText}
              <Icon icon={<ArrowRight />} />
            </Button>
          </Space>
        </div>
      </Space>
    </Card>
  );
}
